// O QR do segundo fator.
//
// A API devolve o `otpauth://` — desenhar o quadrado é trabalho da interface.
// Feito no NAVEGADOR, de propósito: o segredo não precisa dar uma volta a mais
// pelo servidor só para virar imagem, e assim ele não aparece em log de proxy
// nem em cache de CDN.

import { useEffect, useRef, useState } from "react";
import QRCode from "qrcode";

export function QR({ uri, tamanho = 192 }: { uri: string; tamanho?: number }) {
  const tela = useRef<HTMLCanvasElement>(null);
  const [erro, setErro] = useState(false);

  useEffect(() => {
    if (!tela.current) return;
    QRCode.toCanvas(tela.current, uri, {
      width: tamanho,
      margin: 1,
      // Correção de erro média: o QR continua legível com um dedo ou um
      // reflexo cobrindo parte dele, sem inchar o quadrado.
      errorCorrectionLevel: "M",
    }).catch(() => setErro(true));
  }, [uri, tamanho]);

  if (erro) {
    // Sem o quadrado ainda dá para ativar: todo aplicativo autenticador aceita
    // o segredo digitado. Mostrar erro e mais nada trancaria o usuário.
    return (
      <p className="text-sm text-perigo">
        Não foi possível desenhar o QR. Use o código manual, abaixo.
      </p>
    );
  }
  return <canvas ref={tela} width={tamanho} height={tamanho} aria-label="QR do segundo fator" />;
}
